// extracted by mini-css-extract-plugin
export default {"information":"Information_information__RO3r2","formClose":"Information_formClose__5pQDJ","caption":"Information_caption__93snE","message":"Information_message__DyC0N"};